import { render, staticRenderFns } from "./Paasikivi.vue?vue&type=template&id=0472419b&scoped=true"
var script = {}
import style0 from "./Paasikivi.vue?vue&type=style&index=0&id=0472419b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472419b",
  null
  
)

export default component.exports